import {
  CONFIRMED_GET_ADMIN_USERS,
  CONFIRMED_ADD_ADMIN_USER,
  CONFIRMED_UPDATE_ADMIN_USER,
  CONFIRMED_DELETE_ADMIN_USER,
} from "../actions/AdminUserType";
import {
  getAdminUsers,
  addAdminUser,
  updateAdminUser,
  deleteAdminUser,
  formatAdminUsers,
} from "../../services/AdminUserService";
import swal from "sweetalert";
import { handleError, handleSuccess, showErrorAlert } from "../../services/ErrorHandlingService";

// Get token
function getAuthToken(getState) {
  const stateToken = getState().auth?.authKey;
  if (stateToken) return stateToken;
  const storedUser = localStorage.getItem("userDetails");
  return storedUser ? JSON.parse(storedUser).token : null;
}
''
// export function getAdminUsersAction(pagination = false, pageid = 0, search_by = "", search_keyword = "",sort_by ="", sort_order = "") {
//   return async (dispatch, getState) => {
//     try {
//       const response = await getAdminUsers(pagination, pageid, search_by, search_keyword,sort_by,sort_order);

//       if (response && response.status === 200 && response.data) {
//         if (response.data.status === "success" && response.data.data) {
//           const adminUsers = formatAdminUsers(response.data.data);
//           dispatch({ type: CONFIRMED_GET_ADMIN_USERS, payload: adminUsers });
//         } else {
//           handleError("Failed to get AdminUsers: Server error");
//         }
//       } else {
//         handleError("Failed to get AdminUsers: Network error");
//       }
//     } catch (error) {
//       console.error("API Error:", error.response || error);
//       showErrorAlert("Failed to get AdminUsers");
//     }
//   };
// }

// New: Add Admin User Action
export function getAdminUsersAction(
  pagination = false, 
  pageid = 0, 
  search_by = "", 
  search_keyword = "",
  sort_by = "", 
  sort_order = ""
) {
  return async (dispatch, getState) => {
    try {
      const token = getAuthToken(getState);
      const response = await getAdminUsers(
        pagination, 
        pageid, 
        search_by, 
        search_keyword,
        sort_by,
        sort_order,
        token
      );
      
      if (response && response.status === 200 && response.data) {
        if (response.data.status === "success" && response.data.data) {
          const adminUsers = formatAdminUsers(response.data.data);
          dispatch({ 
            type: CONFIRMED_GET_ADMIN_USERS, 
            payload: {
              adminUsers: adminUsers,
              num_rows: response.data.num_rows || 0
            }
          });
        } else {
          handleError("Failed to get Users: Server error");
        }
      } else {
        handleError("Failed to get Users: Network error");
      }
    } catch (error) {
      console.error("API Error:", error.response || error);
      showErrorAlert("Failed to get Users");
    }
  };
}


export function addAdminUserAction(userData, history) {
  return async (dispatch) => {
    try {
      const adminUser = {
        role_id: userData.role_id,
        admin_name: userData.admin_name,
        admin_username: userData.admin_username,
        admin_password: userData.admin_password,
        admin_cpassword: userData.admin_cpassword,
        admin_email: userData.admin_email,
        admin_mobile: userData.admin_mobile,
        admin_status: userData.admin_status,
        disease_ids: JSON.stringify(
          Array.isArray(userData.disease_ids)
            ? userData.disease_ids
            : userData.disease_ids
              ? [userData.disease_ids]
              : []
        ),
        branch_id: userData.branch_id,

        daily_calling_capacity: userData.daily_calling_capacity || undefined,
        max_active_patients: userData.max_active_patients || undefined,
        // enable_2fa: userData.enable_2fa ? "Yes" : "No"
        enable_2fa: userData.enable_2fa
      };
      console.log(adminUser);
      let response = await addAdminUser(adminUser);
      console.log(response);
      if (response && response.status === 200 && response.data) {
        const data = response.data;
        dispatch({ type: CONFIRMED_ADD_ADMIN_USER, payload: adminUser });
        if (history) history.push("/add-user");
        handleSuccess("User created successfully!");
      } else {
        showErrorAlert("Failed to create User");
      }
    } catch (error) {
      console.error(error);
      showErrorAlert("Failed to create User");
    }
  };
}

export function updateAdminUserAction(adminUser, history) {
  return async (dispatch) => {
    try {
      const formattedUser = {
        ...adminUser,

        // ❌ REMOVE stringify
        branch_id: adminUser.branch_id?.[0] || "",

        disease_ids: adminUser.disease_ids,
      };

      console.log("FINAL UPDATE PAYLOAD:", formattedUser);

      let response = await updateAdminUser(formattedUser);

      if (response) {
        dispatch({ type: CONFIRMED_UPDATE_ADMIN_USER, payload: formattedUser });
        if (history) history.push("/users");
      } else {
        showErrorAlert("Failed to update users");
      }
    } catch (error) {
      console.log(error);
      showErrorAlert("Failed to update users");
    }
  };
}

export function deleteAdminUserAction(adminUser, history) {
  return async (dispatch) => {
    try {
      await deleteAdminUser({ delete_user_id: adminUser.admin_id });
      dispatch({
        type: CONFIRMED_DELETE_ADMIN_USER,
        payload: { admin_id: adminUser.admin_id },
      });
      if (history) history.push("/users");
      //handleSuccess("AdminUser deleted successfully!");
    } catch (error) {
      console.error(error);
      showErrorAlert("Failed to delete AdminUser");
    }
  };
}
